import React, { useEffect } from 'react';
import { Modal, Button, Form, InputNumber, Input } from 'antd';

export default function WithdrawPointsModal({
  open,
  onCancel,
  user,
  onSubmit,
  submitLoading,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await onSubmit({
        points: values.points,
        notes: values.notes?.trim() ?? '',
      });
      onCancel();
    } catch (err) {
      if (err.errorFields) return;
      // API errors are handled by parent; avoid unhandled rejection
    }
  };

  if (!user) return null;

  return (
    <Modal
      title="Withdraw points"
      open={!!open}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} className="app-btn-cancel">
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit}
          loading={submitLoading}
          className="app-btn-primary"
        >
          Withdraw
        </Button>,
      ]}
      destroyOnClose
      width={400}
      className="user-list-modal"
    >
      <p style={{ marginBottom: 16 }}>
        Withdraw points from <strong>{user.name || user.email}</strong>.
      </p>
      <Form form={form} layout="vertical" initialValues={{ points: undefined, notes: '' }}>
        <Form.Item
          name="points"
          label="Points to withdraw"
          rules={[
            { required: true, message: 'Enter points to withdraw' },
            { type: 'number', min: 1, message: 'Must be at least 1' },
          ]}
        >
          <InputNumber min={1} style={{ width: '100%' }} placeholder="e.g. 50" />
        </Form.Item>
        <Form.Item name="notes" label="Notes (optional)">
          <Input.TextArea rows={2} placeholder="Reason for withdrawal" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
